document.addEventListener("DOMContentLoaded", () => {
  const block = document.querySelector(".gacha-block");
  if (!block) return;

  const customerId = block.dataset.customerId;

  const loadingEl = document.getElementById("gachaLoading");
  const noCampaignEl = document.getElementById("gachaNoCampaign");
  const notEligibleEl = document.getElementById("gachaNotEligible");
  const drawNotStartedEl = document.getElementById("gachaDrawNotStarted");
  const drawEndedEl = document.getElementById("gachaDrawEnded");
  const drawSectionEl = document.getElementById("gachaDrawSection");
  const drawBtn = document.getElementById("gachaDrawBtn");
  const drawMessageEl = document.getElementById("gachaDrawMessage");
  const resultSectionEl = document.getElementById("gachaResultSection");
  const resultBadgeEl = document.getElementById("gachaResultBadge");
  const resultLabelEl = document.getElementById("gachaResultLabel");
  const resultAmountEl = document.getElementById("gachaResultAmount");
  const resultCodeEl = document.getElementById("gachaResultCode");
  const copyBtn = document.getElementById("gachaCopyBtn");
  const copyMessageEl = document.getElementById("gachaCopyMessage");

  // 等級ラベルに含まれる金額に応じて配色を切り替える（バナー画像のクーポン券の色に対応）
  const TIER_COLORS = {
    5000: { accent: "#c96b63", accentSoft: "#f6dedb", bg: "#fdf4f2" },
    3000: { accent: "#8a6bb0", accentSoft: "#e6ddf1", bg: "#f6f2fa" },
    2000: { accent: "#c69a3f", accentSoft: "#f1e2bd", bg: "#fbf6ea" },
    1000: { accent: "#3f9d97", accentSoft: "#cdeae7", bg: "#eef8f7" },
  };
  const DEFAULT_TIER_COLORS = { accent: "#b08d57", accentSoft: "#ecdfc4", bg: "#fbf8f1" };

  function extractAmount(label) {
    const match = (label || "").match(/[\d,]+/);
    return match ? Number(match[0].replace(/,/g, "")) : null;
  }

  function getTierColors(label) {
    const amount = extractAmount(label);
    return (amount && TIER_COLORS[amount]) || DEFAULT_TIER_COLORS;
  }

  function hideAllSections() {
    [noCampaignEl, notEligibleEl, drawNotStartedEl, drawEndedEl, drawSectionEl, resultSectionEl].forEach(el => {
      el.style.display = "none";
    });
  }

  function showDrawMessage(message) {
    drawMessageEl.textContent = message;
    drawMessageEl.className = "gacha-message error";
    drawMessageEl.style.display = "block";
  }

  function showResult(grade, discountCode) {
    const colors = getTierColors(grade.label);
    resultSectionEl.style.setProperty("--gacha-accent", colors.accent);
    resultSectionEl.style.setProperty("--gacha-accent-soft", colors.accentSoft);
    resultSectionEl.style.setProperty("--gacha-bg", colors.bg);

    const amount = extractAmount(grade.label);
    resultBadgeEl.textContent = amount ? `${amount.toLocaleString("ja-JP")}円` : "WIN";
    resultLabelEl.textContent = grade.label || "";
    resultAmountEl.textContent = grade.label || "";
    resultCodeEl.textContent = discountCode || grade.discountCode || "";

    hideAllSections();
    resultSectionEl.style.display = "block";
  }

  async function loadStatus() {
    try {
      const response = await fetch(`/apps/avielans/gacha?customerId=${customerId}`);
      const result = await response.json();

      loadingEl.style.display = "none";

      if (!result.success) {
        throw new Error(result.error || "状態の取得に失敗しました");
      }

      hideAllSections();

      if (result.status === "no_campaign") {
        noCampaignEl.style.display = "block";
      } else if (result.status === "not_eligible") {
        notEligibleEl.style.display = "block";
      } else if (result.status === "draw_not_started") {
        drawNotStartedEl.style.display = "block";
      } else if (result.status === "draw_ended") {
        drawEndedEl.style.display = "block";
      } else if (result.status === "eligible") {
        drawSectionEl.style.display = "block";
      } else if (result.status === "drawn") {
        showResult(result.grade, result.grade?.discountCode);
      }
    } catch (error) {
      console.error("ガチャ状態取得エラー:", error);
      loadingEl.textContent = "状態の取得に失敗しました。ページを再読み込みしてください。";
    }
  }

  loadStatus();

  drawBtn.addEventListener("click", async () => {
    if (drawBtn.disabled) return;
    drawBtn.disabled = true;
    drawBtn.querySelector(".gacha-draw-btn-label").textContent = "抽選中...";
    drawMessageEl.style.display = "none";

    try {
      const response = await fetch("/apps/avielans/gacha", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ customerId }),
      });

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.message || "抽選に失敗しました");
      }

      showResult(result.grade, result.discountCode);
    } catch (error) {
      console.error("抽選エラー:", error);
      showDrawMessage(error.message || "エラーが発生しました");
    } finally {
      drawBtn.disabled = false;
      drawBtn.querySelector(".gacha-draw-btn-label").textContent = "ガチャを引く";
    }
  });

  copyBtn.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(resultCodeEl.textContent);
      copyMessageEl.style.display = "block";
      setTimeout(() => { copyMessageEl.style.display = "none"; }, 3000);
    } catch (error) {
      console.error("コピーエラー:", error);
    }
  });
});
